<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Отправка E-mail организациям') }}</h1>
    <div class="account-cards">
      <div class="bgw-pdg-20">
        <h3>{{ $t('Отправка E-mail организациям') }}</h3>
        <v-form ref="form" @submit.prevent="sendNotification" lazy-validation>
          <div class="account-card-item">
            <div class="quota-fields">
              <div class="quota-field field-block" :class="{ invalid: $v.notification.letterType.$error }">
                <label>{{ $t('Тип e-mail') }}:</label>
                <div class="select-def size-md-2">
                  <v-select
                    :items="refLetterType"
                    item-value="id"
                    item-text="transName"
                    v-model="notification.letterType"
                    outlined
                    dense
                    required
                    clearable
                    return-object
                    @change="setTitleAndText"
                  />
                </div>
              </div>
              <div class="quota-field field-block">
                <label>{{ $t('Кому') }}:</label>
                <div class="select-def size-md-2">
                  <v-select
                    :items="refOoptType"
                    item-value="id"
                    item-text="transName"
                    v-model="notification.ooptType"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="account-card-item data-other-species">
            <div class="form-group" :class="{ invalid: $v.notification.title.$error }">
              <label>{{ $t('Тема') }}:</label>
              <v-text-field
                v-model="notification.title"
                required
                outlined
                dense
              />
            </div>
            <div class="form-group" :class="{ invalid: $v.notification.text.$error }">
              <label>{{ $t('Текст') }}:</label>
              <ckeditor
                :editor="editor"
                v-model="notification.text"
                :config="editorConfig"
              />
            </div>
          </div>
          <!--Кнопки действии-->
          <div class="form-action text-center">
            <button
              class="btn btn-default blue"
              type="submit"
            >
              {{ $t('Отправить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Notification from '@/model/notification'

// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  data: () => ({
    breadcrumbs: [],
    notification: {
      ooptType: null,
      title: null,
      text: null,
      letterType: null
    },
    refOoptType: [],
    refLetterType: [],
    rules: {
      notification: {
        text: { required },
        title: { required },
        letterType: { required }
      }
    },
    // editor
    editor: ClassicEditor,
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        HeadingPlugin,
        HorizontalLine,
        Alignment,
        Table,
        TableToolbar
      ],
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'alignment',
        '|',
        'horizontalLine',
        '|',
        'undo',
        'redo',
        '|',
        'insertTable'
      ],
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      heading: {
        options: [
          {
            model: 'paragraph',
            title: 'Paragraph',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          }
        ]
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      Notification.getFormData().then((response) => {
        this.refOoptType = response.data.refOoptType
        this.refLetterType = response.data.refLetterType
        this.generateBreadcrumbs()
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    setTitleAndText () {
      this.notification.title = this.notification.letterType.transTitle ? this.notification.letterType.transTitle : ''
      this.notification.text = this.notification.letterType.transText ? this.notification.letterType.transText : ''
      this.$v.$reset()
    },
    // обновление заявки
    sendNotification () {
      if (!this.validateForm()) {
        return
      }
      const data = {
        text: this.notification.text,
        title: this.notification.title,
        letterType: this.notification.letterType.id,
        ooptType: this.notification.ooptType ? this.notification.ooptType : null
      }
      this.setLoading(true)
      Notification.sendNotification(data).then((response) => {
        if (response.status === 200) {
          this.$router.push({
            name: 'success-notification'
          })
        }
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
      })
      this.setLoading(false)
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Отправка E-mail организациям'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'MyOrganization'
      })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.flexbox {
  .flex-item {
    label {
      display: block;
      margin-bottom: 5px;
    }
  }
}
</style>
